// extracted by mini-css-extract-plugin
export var alertIcon = "_uq-0";